import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=056aabef&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=056aabef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056aabef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056aabef')) {
      api.createRecord('056aabef', component.options)
    } else {
      api.reload('056aabef', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=056aabef&scoped=true&", function () {
      api.rerender('056aabef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/Settings.vue"
export default component.exports